import axiosInstance from './axiosConfig';


// create review rating here
export const createReviewRating = async (payload) => {
  const response = await axiosInstance.post(`/app_reviews`,payload);
  return response.data;
};

// get rating data here
export const getReviewRating = async (page, pageSize) => {
  const response = await axiosInstance.get(`/app_reviews/summary`);
  return response.data;
};

// get review data here
export const getUserReviewComment = async (page, pageSize) => {
  const response = await axiosInstance.get(`/app_reviews`);
  return response.data;
};


export const postReviewReaction = async (reviewId, reactionType) => {
  return  await axiosInstance.post(`/app_reviews/${reviewId}/review_reaction`, {
    reaction_type: reactionType
  });
};


// check review rating modal show eligibility rating data here
export const checkReviewEligibility = async (page, pageSize) => {
  const response = await axiosInstance.get(`/app_reviews/check_review_eligibility`);
  return response.data;
};
